export default __webpack_public_path__ + "static/media/NUS_finTech_Lab_Logo_1-removebg-preview.9ab89134.png";